const Dashboard = () => import("./dashboard/views/Dashboard.vue");
const ViewAuditTrail = () =>
  import("./payment-wallet/views/ViewAuditTrail.vue");
import LoanRoutes from "./loan/routes";
import SalaryManagementRoutes from "./salaryManagement/routes";
import BenefitAndDeductionRoutes from "./benefits-and-deduction/routes.js";
import PaymentWallet from "./payment-wallet/routes.js";
import ReportRoutes from "./report/routes.js";
import PayPackageRoutes from "./payPackage/routes";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "loan",
    redirect: "/admin/payroll/loan/loan-request/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: LoanRoutes,
  },
  {
    path: "salary-management",
    redirect: "/admin/payroll/salary-management/payment-schedule",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: SalaryManagementRoutes,
  },
  {
    path: "benefit-deduction",
    redirect: "/admin/payroll/benefit-deduction/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: BenefitAndDeductionRoutes,
  },
  {
    path: "pay-package",
    redirect: "/admin/payroll/pay-package/all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: PayPackageRoutes,
  },
  {
    path: "payment-wallet",
    redirect: "/admin/payroll/payment-wallet/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: PaymentWallet,
  },
  {
    path: "report",
    redirect: "/admin/payroll/report/generate",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: ReportRoutes,
  },
  {
    path: "audit-trail",
    redirect: "/admin/payroll/audit-trail/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "view-all",
        component: ViewAuditTrail,
      },
      {
        path: "view/:id",
        component: ViewAuditTrail,
      },
    ],
  },
];
